import { render, staticRenderFns } from "./dialog_transaction.vue?vue&type=template&id=ef72f0f2&scoped=true"
import script from "./dialog_transaction.vue?vue&type=script&lang=js"
export * from "./dialog_transaction.vue?vue&type=script&lang=js"
import style0 from "./dialog_transaction.vue?vue&type=style&index=0&id=ef72f0f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef72f0f2",
  null
  
)

export default component.exports